import { useDecisionMakerProfilePageData } from '#src/app/pages/decisionMaker/profile/pageContext';

type Result = ModelHookResult<{
	totalEndorsers: number;
	categories: Array<{ category: string; count: number; color: string }>;
	ariaLabelText: string;
}>;

const ENDORSEMENT_CATEGORY_TO_NAME_COLOR: Record<string, { name: string; color: string }> = {
	COMMUNITY_LEADER: {
		name: 'Community Leader',
		color: 'hsl(32, 90%, 55%)',
	},
	BUSINESS: {
		name: 'Business',
		color: 'hsl(265, 9%, 37%)',
	},
	ISSUE_ADVOCACY: {
		name: 'Issue Advocacy',
		color: 'hsl(260, 14%, 75%)',
	},
	LABOR_UNIONS: {
		name: 'Labor Unions',
		color: 'hsl(226, 100%, 64%)',
	},

	NEWS_OUTLETS: {
		name: 'News Outlets',
		color: 'hsl(279, 100%, 64%)',
	},
	PARTY_LEADERS: {
		name: 'Party Leaders',
		color: 'hsl(145, 96%, 36%)',
	},
	UNKNOWN: {
		name: 'Unknown',
		color: 'hsl(264, 29%, 93%)',
	},
};

export function useAdvocacySupport(): Result {
	const {
		data: { enrichedData },
	} = useDecisionMakerProfilePageData();

	const endorsers = enrichedData?.endorsementsOverview?.endorsers || [];
	const endorsementCategoryMap: Record<string, number> = {};

	for (const endorser of endorsers) {
		const category = endorser.endorserCategory;
		if (!endorsementCategoryMap[category]) {
			endorsementCategoryMap[category] = 1;
		} else {
			endorsementCategoryMap[category] += 1;
		}
	}

	const categories = Object.keys(endorsementCategoryMap)
		.map((category) => ({
			category: ENDORSEMENT_CATEGORY_TO_NAME_COLOR[category].name,
			count: endorsementCategoryMap[category],
			color: ENDORSEMENT_CATEGORY_TO_NAME_COLOR[category].color,
		}))
		.sort((a, b) => {
			return b.count - a.count;
		});

	const ariaLabelText = `Community backing composition by category: ${categories.map((c) => `${c.count} ${c.category}`).join(', ')}`;

	return {
		data: {
			totalEndorsers: endorsers.length,
			categories,
			ariaLabelText,
		},
	};
}
